export const setChartLoanding = ({ commit }, payload) => {
    commit("setChartLoanding", payload);
};
export const setChartList = ({ commit }, payload) => {
    commit("setChartList", payload);
};
export const setChart = ({ commit }, payload) => {
    commit("setChart", payload);
};
export const setBackgroundColorChart = ({ commit }, payload) => {
    commit("setBackgroundColorChart", payload)
};
export const setDataChart = ({ commit }, payload) => {
    commit("setDataChart", payload)
};
export const setLabelsChart = ({ commit }, payload) => {
    commit("setLabelsChart", payload)
};
export const setApis = ({ commit }, payload) => {
    commit("setApis", payload);
};
export const setApi = ({ commit }, payload) => {
    commit("setApi", payload);
};
export const resetApiState = ({ commit }) => {
    commit("setResetApiState");
};
export const setFormHasChanged = ({ commit }, payload) => {
    commit("setFormHasChanged", payload);
};
export const setMateriaisUteisHasChanged = ({ commit }, payload) => {
    commit("setMateriaisUteisHasChanged", payload);
};
export const setNameApi = ({ commit }, payload) => {
    commit("setFormHasChanged", true)
    commit("setNameApi", payload);
};
export const setApprovalApi = ({ commit }, payload) => {
    commit("setApprovalApi", payload)
};
export const setProvider = ({ commit }, payload) => {
    commit("setFormHasChanged", true)
    commit("setProvider", payload);
};
export const setRelatedCategories = ({ commit }, payload) => {
    commit("setFormHasChanged", true)
    commit("setRelatedCategories", payload);
};
export const setDescription = ({ commit }, payload) => {
    commit("setFormHasChanged", true)
    commit("setDescription", payload);
};
export const setImage = ({ commit }, payload) => {
    commit("setFormHasChanged", true)
    commit("setImage", payload);
};
export const setTypeImage = ({ commit }, payload) => {
    commit("setTypeImage", payload);
};
export const setDetailedDescription = ({ commit }, payload) => {
    commit("setFormHasChanged", true)
    commit("setDetailedDescription", payload);
};
export const setMateriaisUteis = ({ commit }, payload) => {
    commit("setMateriaisUteis", payload);
};
export const setEditMaterials = ({ commit }, payload) => {
    commit("setMateriaisUteisHasChanged", true)
    commit("setEditMaterials", payload);
};
export const setEditEndpoint = ({ commit }, payload) => {
    commit("setFormHasChanged", true)
    commit("setEditEndpoint", payload);
};
export const setAddItemMateriaisUteis = ({ commit }, payload) => {
    commit("setMateriaisUteisHasChanged", true)
    commit("setAddItemMateriaisUteis", payload);
};
export const setDeleteItemMateriaisUteis = ({ commit }, payload) => {
    commit("setMateriaisUteisHasChanged", true)
    commit("setDeleteItemMateriaisUteis", payload);
};
export const setDataSwagger = ({ commit }, payload) => {
    commit("setFormHasChanged", true)
    commit("setDataSwagger", payload)
};
export const setVersion = ({ commit }, payload) => {
    commit("setFormHasChanged", true)
    commit("setVersion", payload)
};
export const setBasePath = ({ commit }, payload) => {
    commit("setFormHasChanged", true)
    commit("setBasePath", payload)
};
export const setEndpoints = ({ commit }, payload) => {
    commit("setFormHasChanged", true)
    commit("setEndpoints", payload);
}
export const setGroupList = ({ commit }, payload) => {
    commit("setFormHasChanged", true)
    commit("setGroupList", payload);
};
export const setRemoveGroup = ({ commit }, index) => {
    commit("setFormHasChanged", true)
    commit("setRemoveGroup", index);
};
export const setEditGroup = ({ commit }, payload) => {
    commit("setFormHasChanged", true)
    commit("setEditGroup", payload);
};
export const setNewGroup = ({ commit }, payload) => {
    commit("setFormHasChanged", true)
    commit("setNewGroup", payload);
};
export const setPlanList = ({ commit }, payload) => {
    commit("setFormHasChanged", true)
    commit("setPlanList", payload);
};
export const setRemovePlan = ({ commit }, index) => {
    commit("setFormHasChanged", true)
    commit("setRemovePlan", index);
};
export const setEditPlan = ({ commit }, payload) => {
    commit("setFormHasChanged", true)
    commit("setEditPlan", payload);
};
export const setNewPlan = ({ commit }, payload) => {
    commit("setFormHasChanged", true)
    commit("setNewPlan", payload);
};
export const setBusinessModelType = ({ commit }, type) => {
    commit("setFormHasChanged", true)
    commit("setBusinessModelType", type);
};
export const setRegisterApiTab = ({ commit }, payload) => {
    commit("setRegisterApiTab", payload);
};

export const setRecentlyChangedApi = ({ commit }, payload) => {
    commit("setRecentlyChangedApi", payload);
};

export const setApiDetailsLoading = ({ commit }, payload) => {
    commit("setApiDetailsLoading", payload);
};